import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import MedicalService from "../Services/MedicalService";
import { HSdecrypt } from "../utils/encryptPassword";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import profile from "../assets/images/ProfileImage.jpg";
import ChronicConditionService from "../Services/ChronicConditionService";
import { QRCodeCanvas } from "qrcode.react";
import { convertUTCDate } from "../utils/convertionFunc";
import { Flex, Spin } from "antd";
import PatientService from "../Services/PatientService";
import { FiDownload } from "react-icons/fi";
import { CloseOutlined } from "@ant-design/icons";
import EmcIcon from "../assets/images/Emcicon.png";
import UserIcon from "../assets/images/ProfileImage.jpg";
import DrugIcon from "../assets/images/DrugIcon.png";
import ChronicIcon from "../assets/images/ChronicIcon.png";
import InsuranceIcon from "../assets/images/InsuranceIcon.png";
import MedicationsIcon from "../assets/images/MedicationIcon.png";
import Cardbg from "../assets/images/Cardbg.png";
import CardLogo from "../assets/images/Cardlogo.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { AiOutlineIdcard } from "react-icons/ai";

function EmergencyDataView() {
  const frontRef = useRef();
  const backRef = useRef();
  const [patientQrData, setPatientQrData] = useState();
  const [patDetails, setPatDetails] = useState(null);
  const [chronicConditions, setChronicConditions] = useState([]);
  const [patientAlleryData, setPatientAlleryData] = useState([]);
  const [isLoading, setIsLoading] = useState({
    allergy: false,
    chronics: false,
    drug: false,
  });
  const [medications, setMedications] = useState([]);
  const [isFlipped, setIsFlipped] = useState(false);
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

  useEffect(() => {
    PatientAllergies();
    PatientchronicConditions();
    patientMedication();
    getPatientDetails();
    PatientEmergencyData();
  }, []);

  const getPatientDetails = async () => {
    const payload = {
      patientId: loggedUser.patientId,
    };

    try {
      const response = await PatientService.HSPatientData(payload);
      setPatDetails(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const PatientAllergies = () => {
    setIsLoading((prevState) => ({ ...prevState, allergy: true }));
    let payload = {
      patientCode: loggedUser.patientId,
      status: 1,
    };
    MedicalService.HSPatientAllergyList(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        const parsedAllergyData = JSON.parse(decryptedData);
        const filteredDrugAllergies = parsedAllergyData?.map((item) => ({
          drugAllergy: item["drugAllergy"],
        }));
        setPatientAlleryData(filteredDrugAllergies);
        setIsLoading((prevState) => ({ ...prevState, allergy: false }));
      })
      .catch((error) => {
        console.error(error);
        setIsLoading((prevState) => ({ ...prevState, allergy: false }));
      });
  };

  const PatientchronicConditions = () => {
    setIsLoading((prevState) => ({ ...prevState, chronics: true }));
    let payload = {
      patientId: loggedUser.patientId,
    };
    ChronicConditionService.HSPatientchronicConditions(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setChronicConditions(JSON.parse(decryptedData));
        setIsLoading((prevState) => ({ ...prevState, chronics: false }));
      })
      .catch((error) => {
        console.error(error);
        setIsLoading((prevState) => ({ ...prevState, chronics: false }));
      });
  };

  const patientMedication = () => {
    setIsLoading((prevState) => ({ ...prevState, drug: true }));
    let payload = {
      patientCode: loggedUser.patientId,
      status: 1,
    };
    MedicalService.HSPatientMedication(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setMedications(JSON.parse(decryptedData));
        setIsLoading((prevState) => ({ ...prevState, drug: false }));
      })
      .catch((error) => {
        console.error(error);
        setIsLoading((prevState) => ({ ...prevState, drug: false }));
      });
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;

    if (!frontSide || !backSide) return;

    try {
      backSide.style.display = "none";

      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";

      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
      });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;

      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight
      );

      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const calculateAge = (dob) => {
    const dobData = dob;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };


  const PatientEmergencyData = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      status: 1,
      patientId: patientDataV?.patientId,
    };
    MedicalService.PatientQrList(payload).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        let url =
          "https://doctor-dev.doxzon.com/emergencyqr/" +
          result?.data[0]?.healthCardUrl;
        setPatientQrData(url);
      }
    });
  };

  const generateQRCard = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      createdBy: patientDataV?.patientId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: patientDataV?.patientId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: patientDataV?.patientId,
      status: 1,
    };
    MedicalService.GenerateQr(payload).then((result) => {
      PatientEmergencyData();
    });
  };

  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };

  return (
    <div className="">
      {isLoading.allergy ||
        isLoading.chronics ||
        isLoading.drug ||
        !patDetails ? (
        <div className="h-[250px] flex items-center justify-center">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>
      ) : (
        <div className="">
          <div className="flex justify-end items-center gap-3 mb-2 px-1 mr-8">
            <div
              className="w-8 h-8 bg-[#DDFCFF] rounded-full flex items-center justify-center shadow-sm cursor-pointer hover:bg-[#c5f7ff] transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                handleDownload();
              }}
            >
              <FiDownload className="text-[#189FAA] font-bold w-4 h-4" />
            </div>

          </div>
          <div
            className="relative w-full h-[250px] perspective cursor-pointer"
            onClick={handleCardClick}
          >
            <div
              className={`relative w-full h-full transform-style-preserve-3d transition-transform duration-700 ${isFlipped ? "rotate-y-180" : ""
                }`}
            >
              <div
                className="absolute w-full backface-hidden border-2 border-slate-200 rounded-lg bg-white"
                ref={frontRef}
              >
                <div
                  className="h-12 rounded-md flex justify-between items-center px-2"
                  style={{
                    backgroundImage: `url(${Cardbg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <p className="font-medium text-sm text-white">
                    Emergency Medical Card
                  </p>
                  <img src={CardLogo} alt="" />
                </div>

                <div className="w-full p-2 flex justify-evenly">
                  <div className="flex gap-5 w-[75%] items-center">
                    <div className="w-24 h-24 bg-white border rounded-xl flex items-center justify-center overflow-hidden">
                      {patDetails?.photoNameBase64 ? (
                        <img
                          src={
                            "data:image/jpeg;base64," +
                            patDetails?.photoNameBase64
                          }
                          alt=""
                          className="w-full h-full object-cover rounded-xl"
                        />
                      ) : (
                        <img
                          src={profile}
                          alt=""
                          className="w-full h-full object-cover "
                        />
                      )}
                    </div>
                    <div className="font-inter ">
                      <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                        Name:{" "}
                        <span className="font-bold text-[#197EBC]">
                          {patDetails?.salutation +
                            " " +
                            patDetails?.firstName +
                            " " +
                            patDetails?.lastName}
                        </span>
                      </h4>
                      <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                        Age:{" "}
                        <span className="font-bold text-[#333333]">
                          {calculateAge(patDetails?.ageDob)}
                        </span>
                      </h4>
                      <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                        BloodGroup:{" "}
                        <span className="font-bold text-[#333333]">
                          {patDetails?.bloodGroup}
                        </span>
                      </h4>
                      <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                        Mobile No:{" "}
                        <span className="font-bold text-[#333333]">
                          {patDetails?.mobile}
                        </span>
                      </h4>
                    </div>
                  </div>
                  <div className="w-[25%]">
                    <div className="w-24 h-24 rounded-lg flex items-center justify-center mt-3 bg-white border">
                      {patientQrData && (
                        <QRCodeCanvas
                          value={patientQrData}
                          size={80}
                          className="mt-2"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="h-10 bg-[#002B42] flex items-center gap-3 justify-center mt-2 rounded-lg">
                  <div className="bg-[#EF5050] w-24 h-6 rounded-md flex items-center justify-center">
                    <p className="text-white text-xs font-sans font-medium">Emergency</p>
                  </div>
                  <h6 className="text-xs font-medium text-white">
                    Mobile Number:{" "}
                    <span className="text-sm font-semibold">
                      {patDetails?.emergencyContact}
                    </span>
                  </h6>
                </div>
              </div>
              <div
                className="absolute w-full bg-[#002B42] h-56 rounded-lg backface-hidden rotate-y-180 border-2 border-slate-200"
                ref={backRef}
              >
                <div className="flex flex-col justify-between bg-[#002B42] rounded-md shadow h-full">
                  <div className="flex flex-col items-center text-center justify-center px-4 py-6">
                    <p className="text-sm font-semibold text-white mt-10">
                      Access my personal Health Records At:
                    </p>
                    <a
                      href={`${process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "")}/PHR-ACCESS/${patDetails?.patientId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#189FAA] text-sm mt-1 font-bold underline hover:text-[#117a80] transition"
                    >
                      {`${process.env.REACT_APP_FRONTEND_URL?.replace(/^https?:\/\//, "")}/PHR-ACCESS`}
                    </a>
                  </div>

                  <div className="flex justify-center gap-3 items-center border-t border-gray-200 h-10 bg-gray-50 rounded-b-md">
                    <p className="text-sm font-semibold w-24 h-7 bg-[#0AA0AC] rounded-md text-white flex items-center justify-center">
                      Member ID
                    </p>
                    <div className="flex items-center gap-2">
                      <AiOutlineIdcard className="w-5 h-5" />
                      <p>ID No:</p>
                      <span className="text-sm font-semibold">
                        {patDetails?.patientId}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmergencyDataView;
